import React, {useState} from "react";
import {Navigate, Outlet} from "react-router";

const Auth = ({allowedRoles}) => {

  const [userData] = useState(JSON.parse(localStorage.getItem("doctolikLoginInfo")));

  return allowedRoles.includes(userData?.users?.type) ? <Outlet /> : <Navigate to={"/"} replace />;

};
export default Auth;
